import { theme } from "@/theme";

export const commonTypographyStyles = {
  px: "16px",
  height: "34px",
  display: "flex",
  alignItems: "center",
  borderRadius: 2,
  cursor: "pointer",
  color: theme.palette.primary.main,
  "&.active-link": {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.main,
  },
  "&:hover": {
    opacity: 0.7,
  },
};

export const headerHeight = "100px";
